import { Badge } from '@get-mosh/msh-shared';
import { getHeroImage, getReadingTime } from 'src/helpers/blogPost';
import classNames from 'classnames';
import { PrismicLink } from '@prismicio/react';
import { linkResolver } from 'src/prismicio';
import { BlogPageDocument } from 'prismicio-types';
import { PrismicNextImage } from '@prismicio/next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward, faClock } from '@fortawesome/pro-solid-svg-icons';
import { BLOG_CATEGORIES } from 'src/constants/Blog';

export type CardBlogPostProps = {
    className?: string;
    post: BlogPageDocument;
};

function getVerticalBadgeText(post: BlogPageDocument) {
    if (post.data.vertical) {
        const category = BLOG_CATEGORIES.find(
            (category) =>
                category.type === 'vertical' &&
                category.vertical === post.data.vertical,
        );
        return category?.title;
    }

    return null;
}

const CardBlogPost = ({ className, post }: CardBlogPostProps) => {
    const image = getHeroImage(post.data);
    const verticalBadgeText = getVerticalBadgeText(post);

    return (
        <PrismicLink
            className={classNames(
                className,
                'relative flex flex-col gap-4 rounded-2xl border border-grey-200 bg-white p-4 shadow-md',
            )}
            document={post}
            linkResolver={linkResolver}
            title={post.data.title || ''}
        >
            {image ? (
                <>
                    <PrismicNextImage
                        field={image}
                        className="h-64 w-full rounded-lg object-cover"
                    />
                    <Badge
                        className="absolute right-6 top-6"
                        size="small"
                        variant="tag-medium"
                    >
                        <FontAwesomeIcon icon={faClock} className="mr-2" />
                        {getReadingTime(post.data)}
                    </Badge>
                </>
            ) : null}
            <div className="flex flex-col items-start gap-2">
                <h4>{post.data.title}</h4>
                <div className="flex flex-row flex-wrap gap-2">
                    {post.data.category === 'Category Guides' ? (
                        <Badge size="small" variant="highlight" rounded={false}>
                            <FontAwesomeIcon icon={faAward} className="mr-2" />
                            Recommended
                        </Badge>
                    ) : null}
                    {verticalBadgeText ? (
                        <Badge
                            text={verticalBadgeText}
                            size="small"
                            variant="default"
                            rounded={false}
                        />
                    ) : null}
                </div>
            </div>
        </PrismicLink>
    );
};

export default CardBlogPost;
